import VueCookies from 'vue-cookies'
import AuthenticationConst from '../authentication.const'
import axios from 'axios'
import router from '@/router/router'
import store from '@/store/store'
import $http from '@/plugins/axios'

const AuthService = {
    getToken () {
        return VueCookies.get(AuthenticationConst.TOKEN_KEY)
    },
    setToken (token) {
        return VueCookies.set(AuthenticationConst.TOKEN_KEY, token)
    },
    removeToken () {
        return VueCookies.remove(AuthenticationConst.TOKEN_KEY)
    },
    decodeJWT (token) {
        // copied from here
        // https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
        let base64Url = token.split('.')[1]
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
        return JSON.parse(jsonPayload)
    },
    getProfile () {
        if (store.state.authenticationService === AuthenticationConst.authenticationService.SELF) {
            let profile = this.decodeJWT(this.getToken())
            return Promise.resolve({ data: profile })
        } else {
            return $http.get('/profile/')
        }
    },
    // all in one authenticate function for easy use
    signIn () {
        switch (store.state.authenticationService) {
            case AuthenticationConst.authenticationService.SELF:
                this.signInSelf()
                break
            case AuthenticationConst.authenticationService.FPT_ID:
                this.singInFptId()
                break
            default:
                router.push('/authentication')
        }
    },
    signOut () {
        this.removeToken()
        switch (store.state.authenticationService) {
            case AuthenticationConst.authenticationService.SELF:
                this.signOutSelf()
                break
            case AuthenticationConst.authenticationService.FPT_ID:
                this.signOutFptId()
                break
            default:
                router.push('/authentication')
        }
    },
    signInSelf () {
        router.push('/authentication/self')
    },
    signInSelfToken (email, password) {
        return axios.post(
            process.env.VUE_APP_BASE_API_URL + '/token/',
            { email, password }
        )
    },
    signOutSelf () {
        router.push('/authentication/self')
    },
    // authenticate fpt-id service
    singInFptId () {
        window.location.href = process.env.VUE_APP_AUTHORIZATION_END_POINT + '/auth' + '?' + this.createFptIdUrlParams()
    },
    signOutFptId () {
        window.location.href = `${process.env.VUE_APP_AUTHORIZATION_END_POINT}/logout?post_logout_redirect_uri=${window.location.origin}${process.env.BASE_URL}&client_id=${process.env.VUE_APP_AUTHORIZATION_CLIENT_ID}`
    },
    createFptIdUrlParams () {
        return `client_id=${process.env.VUE_APP_AUTHORIZATION_CLIENT_ID}` +
            `&redirect_uri=${window.location.origin}${process.env.BASE_URL}authentication/fpt-id/success/` +
            `&state=${Math.random().toString(36).substring(2)}` +
            `&response_type=code` +
            `&scope=openid+profile+email+phone`
    },
    getJwtUser (code) {
        let url = process.env.VUE_APP_BASE_API_URL + '/social/jwt_user/fptid/'
        let instance = axios.create({
            headers: {
                common: {
                    'Content-Type': 'application/json'
                }
            }
        })
        return instance.post(url, { code })
    }
}

export default AuthService
